var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classCss,on:{"click":_vm.handleEvent}},[_c('img',{staticClass:"icon-next__icon",attrs:{"src":require("@/assets/chevron-right.png"),"alt":_vm.alt}})])}
var staticRenderFns = []

export { render, staticRenderFns }